(() => {
  'use strict';
  if (window.grSalesSourceGate || /^\/(?:checkouts?|admin)(?:\/|$)/.test(location.pathname)) return;
  window.grSalesSourceGate = { version: '2026-10-20-v1' };
  const config = JSON.parse(document.getElementById('gr-sales-source-config').textContent);
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const noMemory = "I don't remember";
  const own = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
  const safeSale = value => {
    const key = String(value || '').trim().toLowerCase().replace(/^@/, '');
    return config.sales.includes(key) ? key : own(config.aliases, key) ? config.aliases[key] : '';
  };
  const saleFromUtm = utm => {
    for (const key of keys) {
      const value = String(utm[key] || '').toLowerCase();
      const exact = safeSale(value);
      if (exact) return exact;
      for (const code of Object.keys(config.aliases)) {
        const escaped = code.replace(/[.*+?^$()|[\]\\{}]/g, '\\$&');
        if (new RegExp('(^|[^a-z0-9_.])' + escaped + '($|[^a-z0-9_.])').test(value)) return config.aliases[code];
      }
    }
    return '';
  };
  const readStored = key => {
    try {
      const item = JSON.parse(localStorage.getItem(key) || 'null');
      return item && Number.isFinite(item.t) && item.t <= Date.now() && Date.now() - item.t < 30 * 86400000 ? item : null;
    } catch (_) { return null; }
  };
  const tracking = () => {
    const query = new URLSearchParams(location.search);
    const utm = Object.fromEntries(keys.map(key => [key, query.get(key) || '']));
    if (keys.some(key => query.has(key)) || query.has('sales')) {
      const matched = saleFromUtm(utm);
      return { utm, sale: matched || safeSale(query.get('sales')), via: matched ? 'utm' : 'link' };
    }
    let lead = {};
    try { lead = typeof window.grLead === 'function' ? window.grLead() : {}; } catch (_) {}
    keys.forEach(key => {
      try { utm[key] = lead.utm && lead.utm[key] || sessionStorage.getItem('gr_' + key) || ''; } catch (_) {}
    });
    const matched = saleFromUtm(utm);
    if (matched) return { utm, sale: matched, via: 'utm' };
    const storedUtm = readStored('gr_utm');
    if (storedUtm && saleFromUtm(storedUtm.u || {})) return { utm: storedUtm.u, sale: saleFromUtm(storedUtm.u), via: 'utm' };
    const storedSale = readStored('gr_sales');
    return { utm, sale: safeSale(storedSale && storedSale.s), via: 'link' };
  };
  const labelSale = sale => sale ? sale[0].toUpperCase() + sale.slice(1) : '';
  const attributes = (track, source = '', account = '') => {
    const selected = (config.accounts[source] || []).find(item => item.account === account);
    const sale = track.sale || selected && selected.sale || '';
    return {
      ...Object.fromEntries(keys.map(key => [key, String(track.utm[key] || '')])),
      sale, assigned_sale: labelSale(sale), channel_owner: labelSale(sale),
      how_heard: track.sale ? '' : source,
      source_account: track.sale || account === noMemory ? '' : account,
      customer_named_sale: track.sale ? '' : labelSale(sale),
      sale_assigned_by: track.sale ? track.via : sale ? 'khach-chon' : 'unassigned',
      account_remembered: track.sale || !own(config.accounts, source) ? 'not_applicable' : account === noMemory ? 'no' : 'yes',
      attribution_version: '2026-10-20-v1'
    };
  };
  const withAttributes = (href, attrs) => {
    const url = new URL(href, location.origin);
    for (const [key, value] of Object.entries(attrs)) url.searchParams.set('attributes[' + key + ']', value);
    return url.href;
  };
  const saveCart = async attrs => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    try {
      const root = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        signal: controller.signal, body: JSON.stringify({ attributes: attrs })
      });
      if (!response.ok) throw new Error('save');
      const cart = await response.json();
      for (const [key, value] of Object.entries(attrs)) {
        if (String(cart.attributes && cart.attributes[key] || '') !== value) throw new Error('verify');
      }
    } finally { clearTimeout(timer); }
  };
  let pending = null;
  let busy = false;
  let previousFocus = null;
  let dialog, sourceSelect, accountSelect, accountField, error, submit;
  const finish = () => {
    pending = null;
    busy = false;
    if (dialog && dialog.open) dialog.close();
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
  };
  const ensureDialog = () => {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.id = 'gr-sales-source-dialog';
    dialog.setAttribute('aria-labelledby', 'gr-sales-source-title');
    dialog.innerHTML = '<form class="gr-ss-form"><button class="gr-ss-close" type="button" aria-label="Close">&times;</button><h2 id="gr-sales-source-title">How did you hear about us?</h2><label class="gr-ss-label" for="gr-sales-source">Source</label><select id="gr-sales-source" required></select><div id="gr-sales-account-field" hidden><label class="gr-ss-label" for="gr-sales-account">Which account?</label><select id="gr-sales-account"></select></div><p class="gr-ss-error" role="alert" hidden></p><button class="gr-ss-submit" type="submit">Continue to checkout</button></form>';
    document.body.append(dialog);
    sourceSelect = dialog.querySelector('#gr-sales-source');
    accountSelect = dialog.querySelector('#gr-sales-account');
    accountField = dialog.querySelector('#gr-sales-account-field');
    error = dialog.querySelector('.gr-ss-error');
    submit = dialog.querySelector('.gr-ss-submit');
    sourceSelect.append(new Option('Choose one', ''));
    config.sources.forEach(source => sourceSelect.append(new Option(source, source)));
    sourceSelect.addEventListener('change', () => {
      const enabled = own(config.accounts, sourceSelect.value);
      accountField.hidden = !enabled;
      accountSelect.required = enabled;
      accountSelect.disabled = !enabled;
      accountSelect.replaceChildren(new Option('Choose one', ''));
      (config.accounts[sourceSelect.value] || []).forEach(item => accountSelect.append(new Option('@' + item.account, item.account)));
      if (enabled) accountSelect.append(new Option(noMemory, noMemory));
      error.hidden = true;
    });
    dialog.querySelector('.gr-ss-close').addEventListener('click', finish);
    dialog.addEventListener('cancel', event => { event.preventDefault(); if (!busy) finish(); });
    dialog.querySelector('form').addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !pending || !event.currentTarget.reportValidity()) return;
      busy = true;
      dialog.querySelector('.gr-ss-close').disabled = true;
      submit.disabled = true;
      submit.textContent = 'Saving...';
      sourceSelect.disabled = true;
      accountSelect.disabled = true;
      error.hidden = true;
      const action = pending;
      try {
        const latest = tracking();
        await action.go(attributes(latest.sale ? latest : action.track, sourceSelect.value, accountSelect.value));
        finish();
      } catch (_) {
        if (pending === action) {
          error.textContent = "We couldn't save your selection. Please try again.";
          error.hidden = false;
        }
      } finally {
        busy = false;
        dialog.querySelector('.gr-ss-close').disabled = false;
        submit.disabled = false;
        submit.textContent = 'Continue to checkout';
        sourceSelect.disabled = false;
        accountSelect.disabled = accountField.hidden;
      }
    });
  };
  const start = async action => {
    if (pending) return;
    const track = tracking();
    previousFocus = document.activeElement;
    pending = { ...action, track };
    try { await action.go(attributes(track)); finish(); }
    catch (_) { finish(); window.alert("We couldn't save the source. Please try checkout again."); }
  };
  const checkoutPath = url => /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/.test(url.pathname);
  const permalinkPath = url => /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/\d+:\d+(?:,\d+:\d+)*\/?$/.test(url.pathname);
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest && event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.target && link.target !== '_self') return;
    let url;
    try { url = new URL(link.href, location.origin); } catch (_) { return; }
    if (url.origin !== location.origin || !permalinkPath(url) && !checkoutPath(url)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    start({ go: async attrs => {
      await saveCart(attrs);
      window.location.assign(withAttributes(url.href, attrs));
    } });
  }, true);
  const permitted = new WeakSet();
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || permitted.has(form)) return;
    const button = event.submitter;
    if (!button || button.name !== 'checkout') return;
    const url = new URL(form.action, location.origin);
    if (url.origin !== location.origin || !/\/cart\/?$/.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    start({ go: async attrs => {
      await saveCart(attrs);
      for (const [key, value] of Object.entries(attrs)) {
        [...form.elements].filter(input => input.name === 'attributes[' + key + ']').forEach(input => { input.value = value; });
      }
      permitted.add(form);
      try { form.requestSubmit(button); } finally { permitted.delete(form); }
    } });
  }, true);
})();
